import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { BathroomPdp } from 'landings/bathroom-pdp';
import { RemoteProps } from './widgets-types';

export const BathroomPdpRemote: React.FC<RemoteProps> = ({ router, store }) => (
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <BathroomPdp />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
